import type { PFrameInternal } from "@milaboratories/pl-model-middle-layer";
import { PFrame, pprofDump } from "./wrapper";

export const PFrameFactory: PFrameInternal.PFrameFactoryV9 = {
  createPFrame: (options: PFrameInternal.PFrameOptionsV2): PFrameInternal.PFrameV18 => {
    return new PFrame(options);
  },
  pprofDump: async (): Promise<Uint8Array> => {
    return await pprofDump();
  },
};
